/** @module components/ProFooter */
import React from "react";
import { Icon, Alert } from "react-aiot";
import { request, rmlOpts, i18n, getMediaDialogNextZIndex } from "../util";
import { Modal } from ".";
import T from "i18n-react";
/**
 * Show a dialog box with a pro feature.
 *
 * @param [props.feature=undefined] {string} The feature to show
 * @extends React.Component
 */

class ProBox extends React.Component {
  constructor(props) {
    super(props);

    this.redirect = () => {
      window.open(rmlOpts.others.proUrl + "&feature=" + this.props.feature, "_blank").focus();
      this.props.onClose();
    };
  }

  render() {
    let title, modalContent;
    const {
      feature
    } = this.props;

    if (feature) {
      const set = rmlOpts.others.lang.proFeatures[feature];
      title = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
        type: "lock"
      }), " ", set.title, " ", rmlOpts.others.lang.proBoxTitle);
      modalContent = /*#__PURE__*/React.createElement("div", null, !!set.image && /*#__PURE__*/React.createElement("img", {
        src: "https://assets.devowl.io/in-app/wp-real-media-library/".concat(set.image)
      }), /*#__PURE__*/React.createElement(T.p, {
        text: set.description
      }));
    }

    return /*#__PURE__*/React.createElement(Modal, {
      visible: !!modalContent,
      title: title,
      onOk: this.redirect,
      onCancel: this.props.onClose,
      cancelText: i18n("proBoxCancel"),
      okText: i18n("proBoxOk"),
      zIndex: getMediaDialogNextZIndex(),
      className: "rml-probox"
    }, modalContent);
  }

}

async function dismiss() {
  await request({
    location: {
      path: "/notice/lite",
      method: "DELETE"
    }
  });
  window.location.reload();
}

const ProFooter = ({
  dismissible = false,
  feature
}) => /*#__PURE__*/React.createElement(Alert, {
  message: /*#__PURE__*/React.createElement("span", null, rmlOpts.others.lang.proFooterText, " \xB7", " ", /*#__PURE__*/React.createElement("a", {
    href: rmlOpts.others.proUrl + "&feature=" + feature,
    target: "_blank"
  }, rmlOpts.others.lang.proLearnMore), dismissible && /*#__PURE__*/React.createElement(React.Fragment, null, " ", "\xB7", " ", /*#__PURE__*/React.createElement("a", {
    onClick: dismiss,
    href: "#"
  }, rmlOpts.others.lang.proDismiss))),
  type: "info",
  style: {
    marginBottom: "10px"
  }
});

export { ProFooter, ProBox };